import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { ImmersiveHero } from '../components/ImmersiveHero';
import { ScrollingMarquee } from '../components/ScrollingMarquee';
import { StatsCounter } from '../components/StatsCounter';
import { PainPoints3D } from '../components/PainPoints3D';
import { Framework3D } from '../components/Framework3D';
import { WhatsIncluded3D } from '../components/WhatsIncluded3D';
import { Testimonials3D } from '../components/Testimonials3D';
import { BeforeAfter3D } from '../components/BeforeAfter3D';
import { CoachSection3D } from '../components/CoachSection3D';
import { ApplicationForm3D } from '../components/ApplicationForm3D';
import { Footer3D } from '../components/Footer3D';

const LegacyHome = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (isMobile) return;
    const handleMouseMove = (e) => {
      setCursorPos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [isMobile]);

  const scrollToApply = () => {
    document.getElementById('apply')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="App bg-dark relative">
      {!isMobile && (
        <>
          <motion.div
            className="fixed w-8 h-8 border-2 border-gold rounded-full pointer-events-none z-[9999] mix-blend-difference"
            animate={{ x: cursorPos.x - 16, y: cursorPos.y - 16 }}
            transition={{ type: "spring", stiffness: 500, damping: 28 }}
          />
          <motion.div
            className="fixed w-2 h-2 bg-gold rounded-full pointer-events-none z-[9999]"
            animate={{ x: cursorPos.x - 4, y: cursorPos.y - 4 }}
            transition={{ type: "spring", stiffness: 800, damping: 30 }}
          />
        </>
      )}

      <motion.div
        className="fixed top-0 left-0 right-0 h-1 bg-gold origin-left z-[9998]"
        style={{ scaleX }}
      />

      <ImmersiveHero onApplyClick={scrollToApply} />
      <ScrollingMarquee />
      <PainPoints3D />
      <CoachSection3D onApplyClick={scrollToApply} />
      <StatsCounter />
      <div id="framework">
        <Framework3D />
      </div>
      <WhatsIncluded3D />
      <div id="results">
        <Testimonials3D />
      </div>
      <BeforeAfter3D onApplyClick={scrollToApply} />
      <ApplicationForm3D />
      <Footer3D />
    </div>
  );
};

export default LegacyHome;
